
import classnames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface IProps {
  label: React.ReactNode;
  tools?: React.ReactNode[];
  isHovering: boolean;
}

export const TdsFormLabel = (props: IProps) => {
  const { label, tools, isHovering } = props;

  return <div className={'flex justify-between items-center w-full'}>
      <div>{label}</div>
    <div className={classnames({
      ['flex items-center justify-center gap-[4px]']: true,
      [styles.hovering]: !isHovering,
    })}>
      {tools?.map(item => item)}
      </div>
  </div>;
};
